import React from "react";
import CompanySettingIcon from "../icons/CompanySettingIcon";
import "../styles/CompanySetting.css";
import CompanyCards from "./CompanyCards";
import CategorySettings from "./CategorySettings";
import { userService } from "../services/userService";
import Utils from "../utils/Utils";
import HomePageSlider from "./HomePageSlider";
function CompSetting() {
  const isRoot = Utils.parseJwt(userService.getUser()).isRoot;
  return (
    <div className="company-Setting-parent">
      <div className="company-setting-main-container">
        <div className="company-setting-container">
          <CompanySettingIcon />
        </div>
        <div className="company-setting-title-container">
          <div className="company-setting-title">Company Settings</div>
          <div className="company-setting-header-text">
            Manage your active companies and their security settings.
          </div>
        </div>
      </div>
      <CompanyCards />
      {isRoot ? (
        <div className="comp-setting-container">
          <HomePageSlider />
          <div
            className="catalog-cards-slider-header-title"
            style={{ marginBottom: "15px" }}
          >
            Category Settings
          </div>
          <CategorySettings />
        </div>
      ) : null}
    </div>
  );
}

export default CompSetting;
